// 2026-10-20 coder(lq): 页面只提交五字段，展示名称、系统、模式和客户端用户提示都不参与持久化。
export const METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE', 'HEAD', 'OPTIONS']
export const MODES = { OFF: '关闭', AUDIT: '观察', ENFORCE: '正式拦截' }
export const relationOnly = row => row ? Object.fromEntries(
    ['authority', 'service_id', 'resource_id', 'http_method', 'api_path'].map(key => [key, row[key]]),
) : null
export const relationKey = row => JSON.stringify(relationOnly(row))
export function parsePolicy(text) {
    const policy = JSON.parse(text || '{}')
    if (!policy || Array.isArray(policy) || typeof policy !== 'object'
        || (Object.prototype.hasOwnProperty.call(policy, 'systems') && (!policy.systems || Array.isArray(policy.systems) || typeof policy.systems !== 'object'))) {
        throw new Error('系统策略格式不正确，请先修正服务端策略')
    }
    if (('enabled' in policy && typeof policy.enabled !== 'boolean')
        || ('gatewayMode' in policy && !MODES[policy.gatewayMode])
        || ('exemptions' in policy && !Array.isArray(policy.exemptions))) throw new Error('运行开关格式不正确')
    return { enabled: false, gatewayMode: 'OFF', exemptions: [], systems: {}, ...policy }
}
// 2026-10-22 coder(lq): 页面只允许精确方法+路径豁免，不能用前缀或通配符扩大放行范围。
export function parseExemptions(text) {
    const lines = (text || '').split(/\r?\n/).map(value => value.trim()).filter(Boolean)
    if (lines.length > 200 || new Set(lines).size !== lines.length) throw new Error('豁免最多200项且不能重复')
    return lines.map(line => {
        const match = /^(GET|POST|PUT|PATCH|DELETE|HEAD|OPTIONS) (\/[^\s?#{}%*\\;]*)$/.exec(line)
        if (!match || match[2].length > 512 || match[2].includes('//')
            || match[2].split('/').some(part => part === '.' || part === '..')
            || (match[2].length > 1 && match[2].endsWith('/'))) throw new Error('豁免格式应为 GET /service/path，路径不能包含通配符、编码或多余斜杠')
        return { method: match[1], path: match[2] }
    })
}
export function systemBindings(policy, name) {
    const item = policy.systems[name] || {}
    return [...(item.services || []), ...(item.menus || [])]
}
export function normalizeGroup(values) {
    if (!/^[A-Za-z0-9_-]{1,64}$/.test(values.name || '')) throw new Error('系统标识限英文、数字、下划线或短横线')
    const split = value => (value || '').split(/\r?\n/).map(item => item.trim()).filter(Boolean)
    const services = split(values.services), menus = split(values.menus)
    if (services.some(value => !/^(baseservice|cms-native):[A-Za-z0-9_-]{1,64}$/.test(value))
        || menus.some(value => !/^(baseservice|cms-native):[A-Za-z0-9_-]{1,64}:[1-9][0-9]*$/.test(value))) {
        throw new Error('分组格式不正确，请按字段提示填写')
    }
    if (values.mode !== 'OFF' && !services.length && !menus.length) throw new Error('启用的系统必须绑定服务或菜单')
    return { mode: values.mode, services, menus }
}
